/* StudioSoie · recherche prédictive (snippets/ss-search.liquid) — Predictive Search API (/search/suggest.json).
   Produits (image, prix), collections, pages, articles, suggestions de requêtes ; navigation clavier (↑ ↓ ↵ Échap) ;
   recherches récentes (localStorage ss_recent_q, 3 max) ; mode overlay plein écran sur mobile. Vanilla, ES5, sans dépendance. */
(function () {
  'use strict';
  var roots = document.querySelectorAll('[data-ss-search]');
  if (!roots.length) { return; }
  var RECENT_KEY = 'ss_recent_q';
  function readRecent() { try { var a = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function pushRecent(q) { q = (q || '').trim(); if (!q) { return; } var a = readRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); a.unshift(q); try { localStorage.setItem(RECENT_KEY, JSON.stringify(a.slice(0, 3))); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function hl(text, q) {
    var raw = String(text == null ? '' : text); if (!q) { return esc(raw); }
    var words = q.trim().split(/\s+/).filter(function (w) { return w.length > 1; }).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!words.length) { return esc(raw); }
    try {
      var re = new RegExp('(' + words.join('|') + ')', 'ig');
      return raw.split(re).map(function (part, i) { return i % 2 ? '<mark>' + esc(part) + '</mark>' : esc(part); }).join('');
    } catch (e) { return esc(raw); }
  }
  function money(str, fmt) {
    var cents = Math.round(parseFloat(String(str).replace(',', '.')) * 100);
    if (isNaN(cents)) { return esc(str); }
    if (window.SS_MONEY) { return window.SS_MONEY(cents, fmt); }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function img(url, w) { if (!url) { return ''; } try { var u = new URL(url, location.origin); u.searchParams.set('width', String(w)); return u.toString(); } catch (e) { return url; } }

  roots.forEach(function (root) {
    var mode = root.getAttribute('data-mode') || 'inline';
    var input = root.querySelector('[data-ss-search-input]');
    var form = root.querySelector('[data-ss-search-form]');
    var panel = root.querySelector('[data-ss-search-panel]');
    var dflt = root.querySelector('[data-ss-search-default]');
    var results = root.querySelector('[data-ss-search-results]');
    var reset = root.querySelector('[data-ss-search-reset]');
    var recentBox = root.querySelector('[data-ss-search-recent]');
    var recentList = root.querySelector('[data-ss-search-recent-list]');
    var rootUrl = root.getAttribute('data-root') || '/';
    var searchUrl = root.getAttribute('data-search-url') || (rootUrl + 'search');
    var fmt = root.getAttribute('data-money') || '';
    var T = function (k) { return root.getAttribute('data-t-' + k) || ''; };
    if (!input || !panel) { return; }
    var timer = null, lastQ = '', controller = null, isOpen = false;

    /* ---- placeholder animé : un seul titre produit à la fois, fondu discret ---- */
    (function () {
      var list = (root.getAttribute('data-ph') || '').split('|').map(function (t) { return t.trim(); }).filter(Boolean);
      if (!list.length || !form) { return; }
      var ph = document.createElement('span');
      ph.className = 'ss-search__ph'; ph.setAttribute('aria-hidden', 'true');
      var txt = document.createElement('span'); txt.className = 'ss-search__ph-t'; ph.appendChild(txt);
      input.parentNode.insertBefore(ph, input.nextSibling);
      root.classList.add('has-ph');
      var i = 0, tick = null;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function place() {
        var cs = getComputedStyle(input);
        ph.style.left = (input.offsetLeft + parseFloat(cs.paddingLeft || 0)) + 'px';
        ph.style.right = Math.max(0, form.clientWidth - input.offsetLeft - input.offsetWidth + parseFloat(cs.paddingRight || 0)) + 'px';
      }
      function sync() { ph.classList.toggle('is-off', !!input.value || document.activeElement === input); }
      function set(t) { txt.textContent = t; }
      function next() {
        if (document.hidden || ph.classList.contains('is-off') || list.length < 2) { return; }
        i = (i + 1) % list.length;
        if (reduce) { set(list[i]); return; }
        txt.classList.add('is-out');
        setTimeout(function () { set(list[i]); txt.classList.remove('is-out'); txt.classList.add('is-in'); requestAnimationFrame(function () { requestAnimationFrame(function () { txt.classList.remove('is-in'); }); }); }, 320);
      }
      set(list[0]); place(); sync();
      tick = setInterval(next, 3800);
      window.addEventListener('resize', place);
      input.addEventListener('input', sync); input.addEventListener('focus', sync); input.addEventListener('blur', sync);
      if (reset) { reset.addEventListener('click', function () { setTimeout(sync, 0); }); }
      if (mode === 'overlay') { document.querySelectorAll('[data-ss-search-toggle]').forEach(function (b) { b.addEventListener('click', function () { setTimeout(place, 80); }); }); }
    })();

    function renderRecent() {
      if (!recentBox || !recentList) { return; }
      var list = readRecent();
      if (!list.length) { recentBox.hidden = true; return; }
      recentList.innerHTML = list.map(function (q) { return '<a class="ss-search__chip" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last" data-ss-opt data-ss-search-fill="' + esc(q) + '">' + esc(q) + '</a>'; }).join('');
      recentBox.hidden = false;
    }
    function showDefault() { if (dflt) { dflt.hidden = false; } if (results) { results.hidden = true; results.innerHTML = ''; } renderRecent(); }
    function open() {
      if (isOpen) { return; }
      isOpen = true; panel.hidden = false; root.classList.add('is-open'); input.setAttribute('aria-expanded', 'true');
      if (!input.value.trim()) { showDefault(); }
      if (mode === 'inline') { document.documentElement.classList.add('ss-search-inline-open'); }
    }
    function close() {
      if (!isOpen) { return; }
      isOpen = false; panel.hidden = true; root.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); setActive(-1);
      document.documentElement.classList.remove('ss-search-inline-open');
    }
    function openOverlay() {
      root.hidden = false; document.documentElement.classList.add('ss-search-overlay-open');
      requestAnimationFrame(function () { root.classList.add('is-shown'); setTimeout(function () { input.focus(); open(); }, 40); });
    }
    function closeOverlay() {
      root.classList.remove('is-shown'); document.documentElement.classList.remove('ss-search-overlay-open'); close();
      setTimeout(function () { root.hidden = true; }, 220);
      var t = document.querySelector('[data-ss-search-toggle]'); if (t && t.focus) { try { t.focus({ preventScroll: true }); } catch (e) {} }
    }
    if (mode === 'overlay') {
      document.querySelectorAll('[data-ss-search-toggle]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openOverlay(); }); });
      root.querySelectorAll('[data-ss-search-close]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); closeOverlay(); }); });
    }

    /* ---- résultats ---- */
    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [], colls = r.collections || [], pages = r.pages || [], articles = r.articles || [], queries = r.queries || [];
      var html = '';
      if (queries.length) {
        html += '<div class="ss-search__col ss-search__col--queries"><div class="ss-search__h"><span>' + esc(T('queries')) + '</span></div><div class="ss-search__chips">' +
          queries.slice(0, 4).map(function (s) { return '<a class="ss-search__chip" href="' + esc(s.url) + '" data-ss-opt data-ss-search-fill="' + esc(s.text) + '">' + (s.styled_text || esc(s.text)) + '</a>'; }).join('') + '</div></div>';
      }
      if (products.length) {
        html += '<div class="ss-search__col ss-search__col--products"><div class="ss-search__h"><span>' + esc(T('products')) + '</span></div><ul class="ss-search__products" role="list">' +
          products.slice(0, 6).map(function (p) {
            var im = p.featured_image && p.featured_image.url ? '<img src="' + esc(img(p.featured_image.url, 160)) + '" alt="" width="64" height="76" loading="lazy">' : '';
            var price = p.price_min && p.price_max && p.price_min !== p.price_max ? '<span class="ss-search__from">' + esc(T('from')) + '</span> ' + money(p.price_min, fmt) : money(p.price, fmt);
            var cmp = p.compare_at_price_min && parseFloat(p.compare_at_price_min) > parseFloat(p.price_min || p.price) ? '<s>' + money(p.compare_at_price_min, fmt) + '</s>' : '';
            return '<li><a class="ss-search__product' + (p.available === false ? ' is-soldout' : '') + '" href="' + esc(p.url) + '" data-ss-opt><span class="ss-search__thumb">' + im + '</span><span class="ss-search__meta"><span class="ss-search__title">' + hl(p.title, q) + '</span>' + (p.type ? '<span class="ss-search__type">' + esc(p.type) + '</span>' : '') + '</span><span class="ss-search__price">' + cmp + '<span>' + price + '</span></span></a></li>';
          }).join('') + '</ul></div>';
      }
      var side = '';
      if (colls.length) { side += '<div class="ss-search__h"><span>' + esc(T('collections')) + '</span></div><ul class="ss-search__links" role="list">' + colls.slice(0, 4).map(function (c) { return '<li><a href="' + esc(c.url) + '" data-ss-opt>' + hl(c.title, q) + '</a></li>'; }).join('') + '</ul>'; }
      if (articles.length) { side += '<div class="ss-search__h"><span>' + esc(T('articles')) + '</span></div><ul class="ss-search__links" role="list">' + articles.slice(0, 3).map(function (a) { return '<li><a href="' + esc(a.url) + '" data-ss-opt>' + hl(a.title, q) + '</a></li>'; }).join('') + '</ul>'; }
      if (pages.length) { side += '<div class="ss-search__h"><span>' + esc(T('pages')) + '</span></div><ul class="ss-search__links" role="list">' + pages.slice(0, 3).map(function (p) { return '<li><a href="' + esc(p.url) + '" data-ss-opt>' + hl(p.title, q) + '</a></li>'; }).join('') + '</ul>'; }
      if (side) { html += '<div class="ss-search__col ss-search__col--side">' + side + '</div>'; }
      var total = products.length + colls.length + pages.length + articles.length;
      if (!total && !queries.length) {
        html = '<p class="ss-search__none">' + esc(T('none').replace('[terms]', q)) + '</p>';
      }
      html += '<a class="ss-search__all" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last" data-ss-opt data-ss-search-all>' + esc(T('see-all').replace('[terms]', q)) + ' <i class="uil uil-arrow-right" aria-hidden="true"></i></a>';
      results.innerHTML = html; results.hidden = false; if (dflt) { dflt.hidden = true; }
      setActive(-1);
    }
    function search(q) {
      if (controller) { controller.abort(); }
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = rootUrl + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,article,query&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      root.classList.add('is-loading');
      fetch(url, { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (data) { if (q === lastQ) { render(q, data); } })
        .catch(function () {})
        .then(function () { root.classList.remove('is-loading'); });
    }
    function onInput() {
      var q = input.value.trim();
      if (reset) { reset.hidden = !q; }
      open();
      if (!q) { lastQ = ''; showDefault(); return; }
      if (q === lastQ) { return; }
      lastQ = q;
      clearTimeout(timer); timer = setTimeout(function () { search(q); }, 220);
    }
    input.addEventListener('input', onInput);
    input.addEventListener('focus', function () { open(); });
    if (reset) { reset.addEventListener('click', function () { input.value = ''; onInput(); input.focus(); }); }
    root.addEventListener('click', function (e) {
      var fill = e.target.closest('[data-ss-search-fill]');
      if (fill && fill.hasAttribute('data-ss-search-fill')) { pushRecent(fill.getAttribute('data-ss-search-fill')); }
      var clr = e.target.closest('[data-ss-search-clear-recent]');
      if (clr) { e.preventDefault(); try { localStorage.removeItem(RECENT_KEY); } catch (er) {} renderRecent(); }
    });
    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); input.focus(); return; }
      pushRecent(q);
    });

    /* ---- clavier ---- */
    var active = -1;
    function options() { return Array.prototype.slice.call(panel.querySelectorAll('[data-ss-opt]')).filter(function (o) { return o.offsetParent !== null; }); }
    function setActive(i) {
      var opts = options(); active = i;
      opts.forEach(function (o, k) { o.classList.toggle('is-active', k === i); if (k === i) { o.setAttribute('aria-selected', 'true'); o.scrollIntoView({ block: 'nearest' }); } else { o.removeAttribute('aria-selected'); } });
    }
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); if (mode === 'overlay') { closeOverlay(); } else { close(); input.blur(); } return; }
      if (panel.hidden) { return; }
      var opts = options();
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(opts.length - 1, active + 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(-1, active - 1)); }
      else if (e.key === 'Enter' && active >= 0 && opts[active]) { e.preventDefault(); var fill = opts[active].getAttribute('data-ss-search-fill'); pushRecent(fill || input.value); window.location.href = opts[active].getAttribute('href'); }
    });
    document.addEventListener('click', function (e) { if (mode === 'inline' && isOpen && !root.contains(e.target)) { close(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mode === 'overlay' && !root.hidden) { closeOverlay(); } });
    document.addEventListener('focusin', function (e) { if (mode === 'inline' && isOpen && !root.contains(e.target)) { close(); } });
  });
})();
